import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";

import IRThermometer from "./components/IRThermometer";
import RTDPRTThermistor from "./components/RTDPRTThermistor";
import Thermocouple from "./components/Thermocouple";
import ContactTachometer from "./components/ContactTachometer";
import NonContactTachometer from "./components/NonContactTachometer";
import ACHighVoltage from "./components/ACHighVoltage";
import PictureCard from "./components/PictureCard";
import TabContentWrapper from "./components/TabContentWrapper";

// Import images from src so Webpack bundles them
import IRThermometerImg from "./images/IRThermometer.jpg";
import RTDPRTImg from "./images/RTDPRT.jpg";
import ThermocoupleImg from "./images/Thermocouple.jpg";
import ContactTachometerImg from "./images/TachometerContact.jpg";
import NonContactTachometerImg from "./images/NonContactTachometer.jpg";
import ACHighVoltageImg from "./images/ACHighVoltage.jpg";

export default function ScopeCal() {
  const tabs = [
    { label: "IR Thermometer", key: "IR", component: IRThermometer, image: IRThermometerImg },
    { label: "RTD PRT Thermistor", key: "RTD", component: RTDPRTThermistor, image: RTDPRTImg },
    { label: "Thermocouple", key: "TC", component: Thermocouple, image: ThermocoupleImg },
    { label: "Contact Tachometer", key: "ContactTachometer", component: ContactTachometer, image: ContactTachometerImg },
    { label: "Non-Contact Tachometer", key: "NonContactTachometer", component: NonContactTachometer, image: NonContactTachometerImg },
    { label: "AC High Voltage Measure", key: "ACHighVoltage", component: ACHighVoltage, image: ACHighVoltageImg },
  ];

  const [selectedTab, setSelectedTab] = useState("IR"); // default tab

  const currentTab = tabs.find(tab => tab.key === selectedTab);

  return (
    <Box sx={{ height: "100vh", display: "flex" }}>
      {/* Sidebar Tabs */}
      <Box sx={{ width: 200, borderRight: "1px solid #ccc", bgcolor: "#f9f9f9", height: "100%" }}>
        <Tabs
          orientation="vertical"
          value={selectedTab}
          variant="fullWidth"
          onChange={(e, newValue) => setSelectedTab(newValue)}
          sx={{ borderRight: 1, borderColor: "divider", py: 2 }}
        >
          {tabs.map(tab => (
            <Tab
              key={tab.key}
              label={tab.label}
              value={tab.key}
              sx={{
                borderRadius: 1,
                mx: 1,
                mb: 1,
                textTransform: "none",
                border: "1px solid",
                borderColor: "divider",
                "&.Mui-selected": {
                  backgroundColor: "primary.main",
                  color: "white",
                  borderColor: "primary.dark",
                  boxShadow: 2,
                },
              }}
            />
          ))}
        </Tabs>
      </Box>

      {/* Right content area */}
      <Box sx={{ flex: 1, overflow: "auto", p: 2 }}>
        {currentTab && (
          <TabContentWrapper>
            <PictureCard image={currentTab.image} alt={currentTab.label} />
            <currentTab.component />
          </TabContentWrapper>
        )}
      </Box>
    </Box>
  );
}